module.exports = __webpack_public_path__ + "static/media/avator-border.d5a0a9fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/layout-menu/avator-border.png
// module id = 395
// module chunks = 1